// Topbar.jsx
import { Box, IconButton, useTheme, Tooltip, Avatar } from "@mui/material";
import { useContext, useState } from "react";
import { ColorModeContext, tokens } from "../../theme";
import InputBase from "@mui/material/InputBase";
import { useLocation, useNavigate } from "react-router-dom";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import SearchIcon from "@mui/icons-material/Search";

const Topbar = ({ setIsAppSidebar, onLogout }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [profilePic] = useState(
    localStorage.getItem("adminProfilePic") || null,
  );
  const [query, setQuery] = useState("");

  const routeFromQuery = (value) => {
    const q = value.toLowerCase().trim();
    if (!q) return null;
    if (["dashboard", "home", "stats"].some((k) => q.includes(k))) return "/";
    if (["book", "books", "catalog"].some((k) => q.includes(k)))
      return `/books?q=${encodeURIComponent(value)}`;
    if (
      ["invoice", "invoices", "payment", "transaction"].some((k) =>
        q.includes(k),
      )
    )
      return `/invoices?q=${encodeURIComponent(value)}`;
    if (q.includes("bar")) return "/bar";
    if (q.includes("line")) return "/line";
    if (q.includes("pie")) return "/pie";
    if (q.includes("calendar")) return "/calendar";
    if (["event", "add event"].some((k) => q.includes(k))) return "/add-event";
    if (["gallery", "media"].some((k) => q.includes(k)))
      return "/add-gallery-item";
    if (["add book", "new book"].some((k) => q.includes(k)))
      return "/add-book";
    return `/books?q=${encodeURIComponent(value)}`;
  };

  const handleSearch = () => {
    const trimmed = query.trim();
    if (!trimmed) return;
    const target = routeFromQuery(trimmed);
    if (!target) return;
    if (target.startsWith("/books") && location.pathname === "/books") {
      navigate(target, { replace: true });
      return;
    }
    if (target.startsWith("/invoices") && location.pathname === "/invoices") {
      navigate(target, { replace: true });
      return;
    }
    navigate(target);
  };

  return (
    <Box display="flex" justifyContent="space-between" p={2}>
      {/* SEARCH BAR */}
      <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="3px"
        width="min(420px, 100%)"
      >
        <InputBase
          sx={{ ml: 2, flex: 1 }}
          placeholder="Search books, invoices, charts..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSearch();
          }}
        />
        <IconButton type="button" sx={{ p: 1 }} onClick={handleSearch}>
          <SearchIcon />
        </IconButton>
      </Box>

      {/* ICONS */}
      <Box display="flex" alignItems="center" gap={0.5}>
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton>
          <NotificationsOutlinedIcon />
        </IconButton>
        <IconButton>
          <SettingsOutlinedIcon />
        </IconButton>

        {/* Profile avatar */}
        <Avatar
          src={profilePic || undefined}
          sx={{
            width: 34,
            height: 34,
            mx: 0.5,
            border: `2px solid ${colors.greenAccent[500]}`,
            backgroundColor: colors.primary[300],
            color: colors.greenAccent[400],
            fontSize: "14px",
            fontWeight: 700,
          }}
        >
          {!profilePic && "A"}
        </Avatar>

        <Tooltip title="Logout">
          <IconButton
            onClick={onLogout}
            sx={{
              "&:hover": {
                color: "#ef4444",
                backgroundColor: "rgba(239,68,68,0.08)",
              },
              transition: "all 0.2s ease",
            }}
          >
            <LogoutOutlinedIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default Topbar;
